import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import exportLimit from "../../common/export-limit.vue";
import reportService from "./reports-service";
export default {
  name: "partsDueReport",
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      specificSelected: "",
      showData: false,
      exportDialog: false,
      hideSpecific: false,
      showTable: false,
      disableDate: false,
      showPart: false,
      partNum: "",
      partDesc: "",
      mainPage: "",
      excelName: "",
      page: 1,
      displayCost: "",
      totalPages: 0,
      subPage: "",
      restForm: false,
      backSlash: true,
      pageUrl: "",
      showAdd: false,
      refresh: true,
      sDate: "",
      eDate: "",
      selectedProject: "",
      selectedBusiness: "",
      selectedStatus: "",
      selectedCountry: "",
      selectedOrderType: "",
      selectedSODetails: "",
      partSearchKey: "",
      partResultList: [],
      showPartNumDetails: false,
      businessList: [],
      detailsData: [],
      statusList: [],
      countryList: [],
      uniqueCountryList: [],
      uniqueOEM: [],
      orderTypeList: [],
      soList: [],
      uniqueSODetails: [],
      reportData: [],
      startDate: false,
      showStatus: false,
      showCountry: false,
      showOrderType: false,
      showAvailStock: false,
      selectedAvailStock: "",
      availStockList: [
        {
          text: "All",
          value: "All",
        },
        {
          text: "Yes",
          value: "Yes",
        },
        {
          text: "No",
          value: "No",
        },
      ],
      soType: false,
      showSearch: false,
      timeoutId: null,
      endDate: false,
      showAllForm: false,
      maxStartDate: new Date().toISOString().split("T")[0],
      minEndDate: new Date().toISOString().split("T")[0],
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      projectList: [],
      debouncedGetPartList: [],
      totalRecords: 0,
      filterObj: {
        pass: 0,
        user_id: this.userId,
        proj_id: 0,
        part_num: "",
        bu_id: 0,
        status: 0,
        country: "",
        sotype_id: 0,
        order_type: "",
        PageNumber: 1,
        export: 0,
        guid: "",
        stockAvailable: "",
      },
      json_fields: {
        Project: "PROJECT_NAME",
        Business: "BUSINESS_NAME",
        Status: "STATUS",
        Country: "COUNTRY",
        Age: "AGE",
        SO_Number: "SALES_ORDER",
        Line_No: "LINE_NO",
        Line_Type: "SO_TYPE",
        Order_Type: "ORD_TYPE",
        RMA: "RMA",
        Order_No: "CUST_ORDER_NO",
        Cust_PO: "PO_NUM",
        Req_Part: "REQ_PART",
        Shpd_Part: "SHP_PART",
        PClass: "PARENT_CLASS",
        Class: "SHP_CLASS",
        Description: "SHP_DESC",
        OEM: "OEM",
        Qty_Ord: "QTY",
        Aloc: "ALLOC",
        BO: "BO",
        Available: "AVAILABLE",
        Warehouse: "WARE",
        Carrier: "CARRIER",
        Aloc_Date: "ALLOCATED",
        Req_Date: "REQDATE",
        Ship_By_Date: "SHIP_BY_DATE",
        Created_Date: "AUTHDATE",
        Pick_Date: "PickDate",
        BCN: "BCN",
        "Serial Number": "SerialNo",
      },
      headerReport: [
        { text: "Status", value: "STATUS", class: "primary customwhite--text" },
        { text: "Country", align: "start", value: "COUNTRY", class: "primary customwhite--text" },
        { text: "SO_Number", value: "SALES_ORDER", class: "primary customwhite--text" },
        { text: "Line_No", value: "LINE_NO", class: "primary customwhite--text" },
        { text: "Order_Type", value: "ORD_TYPE", class: "primary customwhite--text" },
        { text: "RMA", value: "RMA", class: "primary customwhite--text" },
        { text: "Order_No", value: "CUST_ORDER_NO", class: "primary customwhite--text" },
        { text: "Cust_PO", value: "PO_NUM", class: "primary customwhite--text" },
        { text: "Shpd_Part", value: "SHP_PART", class: "primary customwhite--text" },
        { text: "Class", value: "SHP_CLASS", class: "primary customwhite--text" },
        { text: "Description", value: "SHP_DESC", class: "primary customwhite--text" },
        { text: "Qty_Ord", value: "QTY", class: "primary customwhite--text" },
        { text: "Aloc", value: "ALLOC", class: "primary customwhite--text" },
        { text: "BO", value: "BO", class: "primary customwhite--text" },
        { text: "Avail", value: "AVAILABLE", class: "primary customwhite--text" },
        { text: "Warehouse", value: "WARE", class: "primary customwhite--text" },
        { text: "Carrier", value: "CARRIER", class: "primary customwhite--text" },
        { text: "Ship By Date", value: "SHIP_BY_DATE", class: "primary customwhite--text" },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.filterObj.user_id = this.userId;
    this.getProjectData();
    this.debouncedGetPartList = Utility.debounce(this.getPartList, 500);
  },
  mounted() {},
  computed: {
    sortedBusinessOptions() {
      return Utility.getAllAtTop(this.businessList, "business");
    },
    sortedSOTypeOptions() {
      return Utility.getAllAtTop(this.soList, "so_desc");
    },
  },
  methods: {
    //To add and remove From Fav
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    //To brings page based actions to the page
    actionSetter(action) {
      if (this.actionList !== undefined && this.actionList !== null && this.actionList !== "") {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length == 1 ? true : false;
      } else return false;
    },
    async exportData() {
      this.export50kData = true;
      this.exportDialog = false;
    },
    async getProjectData() {
      let projectData = await reportService.getOpenSODetailsData("post", this.filterObj, false);
      this.projectList = projectData;
    },
    // to export the Execel file
    async exportExcel() {
      if (this.totalRecords <= 15000) {
        this.startDownload();
        this.filterObj.export = 1;
        this.filterObj.guid = "";
        this.excelName =
          "Open_Details_Report" + new Date().toISOString().replace("T", "_").replace("Z", "").replace(".", "").replaceAll("-", "_") + ".xls";
        const response = await this.axios.post("/rt/so_open_orders_report_new_export", this.filterObj);
        let responseData = response.data.body;
        responseData?.forEach((element) => {
          element.SHIP_BY_DATE = Utility.displayDateFormat(element.SHIP_BY_DATE, "MM/DD/YYYY");
          element.REQDATE = Utility.displayDateFormat(element.REQDATE, "MM/DD/YYYY");
          element.AUTHDATE = Utility.displayDateFormat(element.AUTHDATE);
          element.ALLOCATED = Utility.displayDateFormat(element.ALLOCATED);
          element.PickDate = element.PickDate !== null ? Utility.displayDateFormat(element.ALLOCATED) : "";
          element.STATUS = (element.STATUS || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        });
        this.export50kData = false;
        this.finishDownload();
        Utility.exportExcel(responseData, this.json_fields, Utility.excelNewFileName("Open_Shipments_"), "Open Shipments");
      } else {
        this.exportDialog = true;
        this.finishDownload();
        return true;
      }
    },
    //Start the Loader when excel process starts
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    // end the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //on Change Project
    onChangeProject() {
      this.filterObj.proj_id = this.selectedProject;
      this.filterObj.pass = 1;
      this.showAllForm = false;
      this.showGo = false;
      this.showPart = true;
      this.disableDate = true;
      this.specificSelected = false;
      this.hideSpecific = false;
      this.showData = false;
      this.showStatus = false;
      this.showCountry = false;
      this.showOrderType = false;
      this.showAvailStock = false;
      this.selectedAvailStock = "";
      this.soType = false;
      this.showSearch = false;
      this.partDesc = "";
      this.partNum = "";
      this.selectedBusiness = "";
      this.partSearchKey = "";
      this.getBusinessData();
    },
    async getBusinessData() {
      let businessData = await reportService.getOpenSODetailsData("post", this.filterObj, false);
      businessData = [...new Map(businessData.map((item) => [item["business"], item])).values()];
      this.businessList = businessData.map((x) => ({
        business: x.business,
        bu_key: x.bu_key,
      }));
    },
    async onChangeBusiness() {
      this.hideSpecific = true;
      this.filterObj.pass = 2;
      this.filterObj.bu_id = this.selectedBusiness;
      this.detailsData = await reportService.getOpenSODetailsData("post", this.filterObj, false);
      const unquieStatus = [...new Map(this.detailsData.map((item) => [item["status"], item])).values()];
      this.statusList = unquieStatus.map((x) => ({
        status_desc: x.status_desc,
        status: x.status,
      }));
      this.showStatus = true;
      this.showCountry = false;
      this.showOrderType = false;
      this.showAvailStock = false;
      this.selectedAvailStock = "";
      this.soType = false;
      this.displayCost = false;
      this.showSearch = false;
      this.orderTypeList = [];
      this.countryList = [];
      this.orderTypeList = [];
      this.soList = [];
      this.showCost = false;
      this.selectedStatus = "";
      this.selectedBusinessOem = "";
      this.selectedSODetails = "";
    },
    onChangeStatus(status_id) {
      this.filterObj.status = status_id;
      this.uniqueCountryList = this.detailsData.filter((x) => x.status == status_id);
      const uniqueCountry = [...new Map(this.uniqueCountryList.map((item) => [item["sh_country"], item])).values()];
      this.countryList = uniqueCountry.map((x) => ({
        sh_country: x.sh_country,
      }));
      this.showCountry = true;
      this.showData = false;
      this.showOrderType = false;
      this.showAvailStock = false;
      this.selectedAvailStock = "";
      this.soType = false;
      this.displayCost = false;
      this.showSearch = false;
      this.oemList = [];
      this.soList = [];
      this.showCost = false;
      this.selectedSODetails = "";
      this.selectedCountry = "";
      this.selectedOrderType = "";
    },
    onChangeCountry(Country_id) {
      this.filterObj.country = Country_id;
      this.uniqueSODetails = this.uniqueCountryList.filter((x) => x.sh_country == Country_id);
      const uniqueSoDesc = [...new Map(this.uniqueSODetails.map((item) => [item["so_desc"], item])).values()];
      this.soList = uniqueSoDesc.map((x) => ({
        so_desc: x.so_desc,
        so_type_id: x.sotype_key,
      }));
      this.soType = true;
      this.displayCost = true;
      this.showSearch = false;
      this.showData = false;
      this.showCost = false;
      this.selectedSODetails = "";
      this.showOrderType = false;
      this.selectedOrderType = "";
      this.showAvailStock = false;
      this.selectedAvailStock = "";
    },
    onChangeSOType(so_id) {
      this.filterObj.sotype_id = so_id;
      this.unqiueOrderType = this.uniqueCountryList.filter((x) => x.sotype_key == so_id);
      const unqiueOrderType = [...new Map(this.uniqueSODetails.map((item) => [item["order_type"], item])).values()];
      this.orderTypeList = unqiueOrderType.map((x) => ({
        order_type: x.order_type,
      }));
      this.showOrderType = true;
      this.showSearch = true;
      this.showData = false;
      this.selectedOrderType = "";
      this.showAvailStock = true;
      this.selectedAvailStock = "";
    },
    async onClickSearch(PageNumber) {
      this.filterObj.pass = 3;
      this.filterObj.PageNumber = PageNumber;
      this.filterObj.bu_id = this.selectedBusiness;
      this.filterObj.country = this.selectedCountry;
      this.filterObj.status = this.selectedStatus;
      this.filterObj.order_type = this.selectedOrderType;
      this.filterObj.sotype_id = this.selectedSODetails;
      this.filterObj.part_num = this.partSearchKey;
      this.filterObj.guid = "";
      this.filterObj.stockAvailable = this.selectedAvailStock;
      this.filterObj.export = 0;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .post("/rt/so_open_orders_report_new", this.filterObj)
        .then((response) => {
          if (response.status == 200) {
            let responseData = response.data.body;
            this.totalRecords = responseData[0]?.TotalRecords;
            this.totalPages = responseData[0]?.TotalPages;
            this.reportData = responseData;
            if (this.reportData?.length > 0) {
              this.showData = true;
              this.reportData?.forEach((element) => {
                if (element.SHIP_BY_DATE) element.SHIP_BY_DATE = Utility.displayDateFormat(element.SHIP_BY_DATE, "MM/DD/YYYY");
                if (element.REQDATE) element.REQDATE = Utility.displayDateFormat(element.REQDATE, "MM/DD/YYYY");
                element.AUTHDATE = Utility.displayDateFormat(element.AUTHDATE, "MM/DD/YYYY");
                if (element.PickDate) element.PickDate = Utility.displayDateFormat(element?.PickDate, "MM/DD/YYYY");
                if (element.ALLOCATED) element.ALLOCATED = Utility.displayDateFormat(element?.ALLOCATED, "MM/DD/YYYY");
              });
            } else {
              this.reportData = [];
              let Alert = {
                type: "error",
                isShow: true,
                message: "No Record Found",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            this.$vuetify.goTo(0);
            this.showTable = true;
            this.guid = "";
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    resetFunction() {
      this.selectedProject = "";
      this.disableDate = false;
      this.partNum = "";
      this.showData = false;
      this.showGo = true;
      this.partDesc = "";
      this.selectedBusiness = "";
      this.partSearchKey = "";
      this.restForm = false;
      this.showPart = false;
      this.showStatus = false;
      this.specificSelected = false;
      this.showCountry = false;
      this.showOrderType = false;
      this.showAvailStock = false;
      this.selectedAvailStock = "";
      this.soType = false;
      this.displayCost = false;
      this.showAllForm = false;
      this.showSearch = false;
      this.businessList = [];
      this.projectList = [];
      this.statusList = [];
      this.orderTypeList = [];
      this.countryList = [];
      this.orderTypeList = [];
      this.soList = [];
      this.showTable = false;
      this.showCost = false;
      this.selectedStatus = "";
      this.selectedBusinessOem = "";
      this.selectedSODetails = "";
      this.hideSpecific = false;
      this.reportData = [];
      this.totalRecords = 0;
      this.timeoutId = null;
      this.totalPages = 1;
      this.filterObj = {
        user_id: this.userId,
        proj_id: 0,
        part_num: "",
        bu_id: 0,
        status: 0,
        country: "",
        sotype_id: 0,
        order_type: "",
        PageNumber: 1,
        export: 0,
        guid: "",
      };
      this.getProjectData();
    },
    onClickSpecificPartNumber() {
      this.specificSelected = true;
    },
    async searchPartNum() {
      if (this.partSearchKey?.length > 2) {
        this.debouncedGetPartList();
      }
    },
    async getPartList() {
      this.showPartNumDetails = true;
      let SearchObj = {
        UserId: this.userId,
        SearchStr: this.partSearchKey,
        proj_key: this.selectedProject,
      };
      let partResultData = await reportService.showPartNumDetailsData("post", SearchObj, false);
      this.partResultList = partResultData?.Resultset;
    },
    async showPartDesc(item) {
      this.showPartDetails = true;
      this.partNum = item.PartNo;
      this.partDesc = item.Description;
      this.partSearchKey = item.PartNo;
      this.showPartNumDetails = false;
      this.filterObj.part_num = this.partNum;
      let dataExists = await reportService.getOpenSODetailsData("post", this.filterObj, false);
      if (dataExists?.message == "NA" || !dataExists) {
        this.showAllForm = false;
        let Alert = {
          type: "error",
          isShow: true,
          message: "No Record Found",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      } else {
        this.showAllForm = true;
      }
    },
    clearPartShip() {
      this.showPartDetails = false;
      this.partSearchKey = "";
      this.partResultList = [];
      this.partNum = "";
      this.partDesc = "";
    },
  },
  components: {
    breadcrumbComp,
    BackToTop,
    exportLimit,
  },
};
